const signRequest = (config) => {
  config.headers['Authorization'] = 'application ' + process.env.ROUTING_LAMBDA_KEY
}

export {
  signRequest
}



// WEBPACK FOOTER //
// ./src/api/routing-lambda/authorization.js